export const GET_SETTINGS_LIST = 'GET_SETTINGS_LIST';
export const getSettingsList = () => ({
  type: GET_SETTINGS_LIST,
});

export const UPDATE_SETTINGS_LIST = 'UPDATE_SETTINGS_LIST';
export const updateSettingsList = settings => ({
  type: UPDATE_SETTINGS_LIST,
  payload: {
    settings,
  },
});
